import Vue from 'vue'
import VueRouter from "vue-router";
import Layout from "../views/Layout.vue";
import Article from "../views/Article.vue";
import Collect from "../views/Collect.vue";
import Like from "../views/Like.vue";
import User from "../views/User.vue";
import ArticleDetail from "../views/ArticleDetail.vue";

Vue.use(VueRouter)

const router = new VueRouter({
    routes: [
        {path: '/', redirect: '/Article'},
        {path: '/Layout', redirect: '/Article'},
        {
            path: '/Layout',
            component: Layout,
            children: [
                {path: '/Article', component: Article},
                {path: '/Collect', component: Collect},
                {path: '/Like', component: Like},
                {path: '/User', component: User},
            ]
        },
        // {path: '/ArticleDetail', component: ArticleDetail},
        {path: '/ArticleDetail/:id', component: ArticleDetail},
    ]
})

export default router